import script from "./AdminManageRolesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminManageRolesView.vue?vue&type=script&setup=true&lang=js"

import "./AdminManageRolesView.vue?vue&type=style&index=0&id=61560946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61560946"]])

export default __exports__